(function () {
    'use strict';

    function questionSetConfiguration() {
        return {
            restrict: 'E',
            templateUrl: 'siteConfiguration/directives/templates/questionSetConfiguration.html',
            link: function (scope) {

            }
        };
    }

    questionSetConfiguration.$inject = [];

    angular.module('ecap.siteConfiguration').directive('questionSetConfiguration', questionSetConfiguration);
})();
